export const UPDATE_DEPARTURES = 'UPDATE_DEPARTURES';
